import {
  REQ_REQUEST,
  REQ_SUCCESS,
  REQ_ERROR,
  REQ_FREE_DATA,
  REQ_SET_REQUESTS_LOADING_STATE,
  REQ_SET_CURRENT_REQUEST,
  REQ_GET_DOC_STATUS_LIST,
  REQ_SET_REQUEST_FILTER,
  REQ_CLEAR_REQUEST_LIST,
  REQ_GET_REQUEST_LIST, // Получение списка запросов на КП, согласно установленному текущему фильтру
  REQ_CLEAR_APPOINT_LIST,
  REQ_GET_APPOINT_LIST,
  REQ_APPOINT_ADD,
  REQ_APPOINT_CANCEL,
  REQ_CREATE_REQUEST,
  REQ_CANCEL_REQUEST,
  REQ_POST_REQUEST,
  REQ_ADD_FILE,
  REQ_DEL_FILE,
  REQ_CHANGE_COMMENT,
  REQ_DELETE_COMMENT,
  REQ_ADD_ROW,
  REQ_UPDATE_ROW,
  REQ_UPDATE_ROW_PLACE,
  REQ_DEL_ROW

} from '../actions/request'
import axios from 'axios'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'
const state = {
  currentRequest: {},
  requestList: [],
  appointmentsList: [],
  docStatesList: [],
  currentRequestFilter: null,
  reqListLoading: false,
  status: ''
}

const getters = {
  getCurrentRequestState: state => state.currentRequest.CS_ID,
  getCurrentRequestID: state => state.currentRequest.DOC_ID,
  getCurrentRequest: state => state.currentRequest,
  getCurrentRequestComments: state => state.currentRequest.COMMENTS_TAB,
  getCurrentRequestFiles: state => {
    if (typeof state.currentRequest.FILE_LIST !== 'undefined') {
      return state.currentRequest.FILE_LIST
    } else {
      return []
    }
  },
  getCurrentRequestAvailStates: state => {
    if (typeof state.currentRequest.AVAIL_STATUS !== 'undefined') {
      return state.currentRequest.AVAIL_STATUS
    } else {
      return []
    }
  },
  getAppointmentsList: state => {
    return state.appointmentsList
  },
  getCurrentRequestAvailReports: state => state.currentRequest.AVAIL_REPORTS,
  getCurrentRequestList: state => state.requestList,
  getCurrentRequestPositions: state => state.currentRequest.ITEMS,
  getDocStatesList: state => state.docStatesList,
  getReqListLoading: state => state.reqListLoading,
  getCurrentRequestFilter: state => {
    var cf = state.currentRequestFilter
    return cf
  }

}

const actions = {
  [REQ_FREE_DATA]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      commit(REQ_REQUEST)
      commit(REQ_FREE_DATA)
      resolve('success')
    }),
  [REQ_GET_DOC_STATUS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_GET_DOC_STATUS_LIST', topic: 'Добавление файла', error: null })
      commit(REQ_SET_REQUESTS_LOADING_STATE, true)
      axios({ url: '/api/org/orders/getOrdersStatusList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_GET_DOC_STATUS_LIST' })
            commit(REQ_GET_DOC_STATUS_LIST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_GET_DOC_STATUS_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_GET_REQUEST_LIST', result: err })
          reject(new Error(err))
        })
        .finally(() => {
          commit(REQ_SET_REQUESTS_LOADING_STATE, false)
        })
    }),
  [REQ_GET_REQUEST_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_GET_REQUEST_LIST', topic: 'Добавление файла', error: null })
      console.log('Called action REQ_GET_REQUEST_LIST, current filter is  ', state.currentRequestFilter)
      commit(REQ_CLEAR_REQUEST_LIST)
      var filterSet = !(state.currentRequestFilter === null)
      if (filterSet) {
        var reqData = {
          CS_ID: state.currentRequestFilter
        }
      } else {
        dispatch(UI_ERROR, { action: 'REQ_GET_REQUEST_LIST', result: 'Не установлен фильтр состояний' })
        reject(new Error('Не установлен фильтр состояний'))
        return
      }
      commit(REQ_SET_REQUESTS_LOADING_STATE, true)
      axios({ url: '/api/org/orders/getOrdersListNew.php', data: reqData, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_GET_REQUEST_LIST' })
            commit(REQ_GET_REQUEST_LIST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_GET_REQUEST_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_GET_REQUEST_LIST', result: err })
          reject(new Error(err))
        })
        .finally(() => {
          commit(REQ_SET_REQUESTS_LOADING_STATE, false)
        })
    }),
  [REQ_GET_APPOINT_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_GET_APPOINT_LIST', topic: 'Добавление файла', error: null })
      commit(REQ_CLEAR_APPOINT_LIST)
      axios({ url: '/api/org/appointments/getAppointmentsList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_GET_APPOINT_LIST' })
            commit(REQ_GET_APPOINT_LIST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_GET_APPOINT_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_GET_APPOINT_LIST', result: err })
          reject(new Error(err))
        })
    }),
  [REQ_APPOINT_ADD]: ({ commit, dispatch }, item) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_APPOINT_ADD', topic: 'Добавление файла', error: null })
      axios({ url: '/api/org/appointments/addAppointment.php', data: item, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_APPOINT_ADD' })
            commit(REQ_APPOINT_ADD, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_APPOINT_ADD', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_APPOINT_ADD', result: err })
          reject(new Error(err))
        })
    }),
  [REQ_APPOINT_CANCEL]: ({ commit, dispatch }, item) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_APPOINT_CANCEL', topic: 'Добавление файла', error: null })
      axios({ url: '/api/org/appointments/cancelAppointment.php', data: item, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_APPOINT_CANCEL' })
            commit(REQ_APPOINT_CANCEL, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_APPOINT_CANCEL', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_APPOINT_CANCEL', result: err })
          reject(new Error(err))
        })
    }),
  [REQ_SET_REQUEST_FILTER]: ({ commit, dispatch }, filterItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action REQ_SET_REQUEST_FILTER ', filterItem)
      commit(REQ_REQUEST)
      if (filterItem !== state.currentRequestFilter) {
        commit(REQ_SET_REQUEST_FILTER, filterItem)
        commit(REQ_CLEAR_REQUEST_LIST)
        dispatch(REQ_GET_REQUEST_LIST)
          .then(resp => {
            commit(REQ_SUCCESS)
            resolve()
          })
          .catch((err) => {
            commit(REQ_ERROR, err)
            reject(err)
          })
      } else {
        commit(REQ_SUCCESS)
        resolve()
      }
    }),

  [REQ_SET_CURRENT_REQUEST]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action REQ_SET_CURRENT_REQUEST ', requestItem)
      if (requestItem.DOC_ID !== state.currentRequest.DOC_ID) {
        console.log('Setting new current request', requestItem)
        commit(REQ_SET_CURRENT_REQUEST, requestItem)
      }
      resolve()
    }),
  [REQ_CREATE_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_CREATE_REQUEST', topic: 'Добавление файла', error: null })
      axios({ url: '/api/org/orders/createNewOrder.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_CREATE_REQUEST' })
            commit(REQ_CREATE_REQUEST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_CREATE_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_CREATE_REQUEST', result: err })
          reject(new Error(err))
        })
    }),
  [REQ_CANCEL_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_CANCEL_REQUEST', topic: 'Добавление файла', error: null })
      dispatch(REQ_POST_REQUEST, params)
        .then(resp => {
          if (resp.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_CANCEL_REQUEST' })
            commit(REQ_CANCEL_REQUEST, params)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_CANCEL_REQUEST', result: resp.data.error_text })
            reject(new Error(resp.error_text))
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_CANCEL_REQUEST', result: err })
          reject(new Error(err))
        })
    }),
  [REQ_POST_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_POST_REQUEST', topic: 'Добавление файла', error: null })
      axios({ url: '/api/org/orders/postOrder.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_POST_REQUEST' })
            commit(REQ_POST_REQUEST, params)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_POST_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_POST_REQUEST', result: err })
          reject(new Error(err))
        })
    }),
  [REQ_ADD_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_ADD_FILE', topic: 'Добавление файла', error: null })
      axios({ url: '/api/org/orders/uploadOrderDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_ADD_FILE' })
            commit(REQ_ADD_FILE, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_ADD_FILE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_ADD_FILE', result: err })
          reject(new Error(err))
        })
    }),
  [REQ_DEL_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_DEL_FILE', topic: 'Добавление файла', error: null })
      axios({ url: '/api/org/orders/delOrderFile.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_DEL_FILE' })
            commit(REQ_DEL_FILE, params)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_DEL_FILE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_DEL_FILE', result: err })
          reject(new Error(err))
        })
    }),
  [REQ_CHANGE_COMMENT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      commit(REQ_REQUEST)
      axios({ url: '/api/org/orders/updOrderComment.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(REQ_CHANGE_COMMENT, resp.data.data)
            resolve(resp.data.data)
            commit(REQ_SUCCESS)
            // commit(ORG_SET_ORDER, resp.data.data)
          } else {
            commit(REQ_ERROR, 'Ошибка обновления данных в запросе на КП: ' + resp.data.error_text)
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          commit(REQ_ERROR, 'Обновление данных в запросе на КП: ошибка сервера')
          reject(new Error(err))
        })
    }),
  [REQ_DELETE_COMMENT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      commit(REQ_REQUEST)
      axios({ url: '/api/org/orders/delOrderComment.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(REQ_CHANGE_COMMENT, resp.data.data)
            resolve(resp.data.data)
            commit(REQ_SUCCESS)
            // commit(ORG_SET_ORDER, resp.data.data)
          } else {
            commit(REQ_ERROR, 'Ошибка обновления данных в запросе на КП: ' + resp.data.error_text)
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          commit(REQ_ERROR, 'Обновление данных в запросе на КП: ошибка сервера')
          reject(new Error(err))
        })
    }),
  [REQ_ADD_ROW]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      commit(REQ_REQUEST)
      axios({ url: '/api/org/orders/addOrderRow.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            console.log('All rows added', resp.data)
            commit(REQ_ADD_ROW, resp.data.data)
            resolve(resp.data.data)
            commit(REQ_SUCCESS)
          } else {
            commit(REQ_ERROR, 'Ошибка добавления данных в запрос на КП: ' + resp.data.error_text)
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          commit(REQ_ERROR, 'Добавление данных в запрос на КП: ошибка сервера')
          reject(new Error(err))
        })
    }),
  [REQ_UPDATE_ROW]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_UPDATE_ROW', topic: 'Обновление комментария', error: null })
      commit(REQ_REQUEST)
      axios({ url: '/api/org/orders/updOrderRow.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_UPDATE_ROW' })
            commit(REQ_UPDATE_ROW, resp.data.data)
            resolve(resp.data.data)
            commit(REQ_SUCCESS)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_UPDATE_ROW', result: resp.data.error_text })
            commit(REQ_ERROR, 'Ошибка модификации данных в запросе на КП: ' + resp.data.error_text)
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_UPDATE_ROW', result: err })
          commit(REQ_ERROR, 'Модификация данных в запросе на КП: ошибка сервера')
          reject(new Error(err))
        })
    }),
  [REQ_UPDATE_ROW_PLACE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'REQ_UPDATE_ROW_PLACE', topic: 'Обновление места', error: null })
      commit(REQ_REQUEST)
      axios({ url: '/api/org/orders/updOrderRowPlace.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_UPDATE_ROW_PLACE' })
            commit(REQ_UPDATE_ROW_PLACE, resp.data.data)
            resolve(resp.data.data)
            commit(REQ_SUCCESS)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_UPDATE_ROW_PLACE', result: resp.data.error_text })
            commit(REQ_ERROR, 'Ошибка модификации данных в запросе на КП: ' + resp.data.error_text)
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'REQ_UPDATE_ROW_PLACE', result: err })
          commit(REQ_ERROR, 'Модификация данных в запросе на КП: ошибка сервера')
          reject(new Error(err))
        })
    }),
  [REQ_DEL_ROW]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      this.$store.dispatch(UI_REQUEST, { action: 'REQ_DEL_ROW', topic: 'Удаление строки', error: null })
      commit(REQ_REQUEST)
      axios({ url: '/api/org/orders/delOrderRow.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'REQ_DEL_ROW' })
            commit(REQ_DEL_ROW, resp.data.data)
            resolve(resp.data.data)
            commit(REQ_SUCCESS)
          } else {
            dispatch(UI_ERROR, { action: 'REQ_DEL_ROW', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: '', result: err })
          reject(new Error(err))
        })
    })
}

const mutations = {
  [REQ_REQUEST]: state => {
    state.status = 'loading'
  },
  [REQ_SUCCESS]: state => {
    state.status = 'success'
  },
  [REQ_ERROR]: state => {
    state.status = 'error'
  },
  [REQ_FREE_DATA]: state => {
    state.currentRequest = {}
    state.requestList.splice(0, state.requestList.length)
    state.appointmentsList.splice(0, state.appointmentsList.length)
    state.docStatesList.splice(0, state.docStatesList.length)
    state.currentRequestFilter = null
    state.reqListLoading = false
    state.status = ''
  },
  [REQ_GET_DOC_STATUS_LIST]: (state, resp) => {
    state.status = 'success'
    console.log('REQ_GET_DOC_STATUS_LIST mutation initiated, ', resp)
    state.docStatesList = resp
  },
  [REQ_CLEAR_REQUEST_LIST]: (state) => {
    state.status = 'success'
    console.log('REQ_CLEAR_REQUEST_LIST mutation initiated, ')
    state.requestList.splice(0, state.requestList.length)
  },
  [REQ_GET_REQUEST_LIST]: (state, resp) => {
    state.status = 'success'
    console.log('REQ_GET_REQUEST_LIST mutation initiated, ', resp)
    state.requestList = resp
  },
  [REQ_CLEAR_APPOINT_LIST]: (state, resp) => {
    state.status = 'success'
    console.log('REQ_CLEAR_APPOINT_LIST mutation initiated, ', resp)
    state.appointmentsList.splice(0, state.appointmentsList.length)
  },
  [REQ_GET_APPOINT_LIST]: (state, resp) => {
    state.status = 'success'
    console.log('REQ_GET_APPOINT_LIST mutation initiated, ', resp)
    state.appointmentsList = resp
  },
  [REQ_APPOINT_ADD]: (state, resp) => {
    console.log('REQ_APPOINT_ADD mutation called', resp)
    state.appointmentsList.push(resp)
  },
  [REQ_APPOINT_CANCEL]: (state, resp) => {
    console.log('REQ_APPOINT_CANCEL mutation called', resp)
    var reqIndex = state.appointmentsList.findIndex(req => req.EQ_ID === resp.EQ_ID)
    if (reqIndex !== -1) {
      state.appointmentsList.splice(reqIndex, 1, resp)
    }
  },
  [REQ_SET_REQUEST_FILTER]: (state, resp) => {
    state.status = 'success'
    console.log('REQ_SET_REQUEST_FILTER mutation initiated, ', resp)
    state.currentRequestFilter = resp
  },
  [REQ_SET_REQUESTS_LOADING_STATE]: (state, resp) => {
    state.status = 'success'
    console.log('REQ_SET_REQUESTS_LOADING_STATE mutation initiated, ', resp)
    state.reqListLoading = resp
  },
  [REQ_SET_CURRENT_REQUEST]: (state, resp) => {
    state.status = 'success'
    console.log('REQ_SET_CURRENT_REQUEST mutation initiated, ', resp)
    state.currentRequest = resp
  },
  [REQ_CREATE_REQUEST]: (state, orderItem) => {
    console.log('REQ_CREATE_REQUEST mutation initiated', orderItem)
    // Проверяем, является ли текущий фильтр запросов соответствующим состоянию нового запроса
    // eslint-disable-next-line eqeqeq
    if (state.currentRequestFilter == orderItem.CS_ID || state.currentRequestFilter == -5) {
      // Если да, то добавляем новый запрос в гобальный список запросов
      state.requestList.push(orderItem)
    }
  },
  [REQ_CANCEL_REQUEST]: (state, resp) => {
    console.log('REQ_CANCEL_REQUEST mutation called. RESP is ', resp)
    var reqIndex = state.requestList.findIndex(req => req.DOC_ID === resp.DOC_ID)
    if (reqIndex !== -1) {
      state.requestList.splice(reqIndex, 1)
    }
  },
  [REQ_POST_REQUEST]: (state, resp) => {
    console.log('REQ_POST_REQUEST mutation called. RESP is ', resp)
    var reqItem = state.requestList.find(req => req.DOC_ID === resp.DOC_ID)
    if (typeof reqItem !== 'undefined') {
      reqItem.CS_ID = resp.SIGNAL_ID
    }
  },
  [REQ_ADD_FILE]: (state, responce) => {
    console.log('REQ_ADD_FILE mutation called, payload ', responce)
    state.currentRequest.FILE_LIST.push(responce)
  },
  [REQ_DEL_FILE]: (state, responce) => {
    console.log('REQ_DEL_FILE mutation called, payload ', responce)
    const index = state.currentRequest.FILE_LIST.findIndex(itm => itm.DD_ID === responce.DD_ID)
    state.currentRequest.FILE_LIST.splice(index, 1)
  },
  [REQ_CHANGE_COMMENT]: (state, responce) => {
    console.log('REQ_CHANGE_COMMENT mutation called, payload ', responce)
    state.currentRequest.COMMENTS_TAB = responce
  },
  [REQ_ADD_ROW]: (state, responce) => {
    console.log('REQ_ADD_ROW mutation called, payload ', responce)
    responce.forEach(row => {
      state.currentRequest.ITEMS.push(row)
    })
  },
  [REQ_UPDATE_ROW]: (state, responce) => {
    console.log('REQ_UPDATE_ROW mutation called, payload ', responce)
    const index = state.currentRequest.ITEMS.findIndex(itm => itm.CDET_ID === responce.CDET_ID)
    if (index !== -1) {
      state.currentRequest.ITEMS.splice(index, 1, responce)
    }
  },
  [REQ_UPDATE_ROW_PLACE]: (state, responce) => {
    console.log('REQ_UPDATE_ROW_PLACE mutation called, payload ', responce)
    const index = state.currentRequest.ITEMS.findIndex(itm => itm.CDET_ID === responce.CDET_ID)
    if (index !== -1) {
      state.currentRequest.ITEMS.splice(index, 1, responce)
    }
  },
  [REQ_DEL_ROW]: (state, responce) => {
    console.log('REQ_ORDER_DEL_ROW_SUCCESS mutation called, payload', responce)
    const index = state.currentRequest.ITEMS.findIndex(itm => itm.CDET_ID === responce)
    if (index >= 0) {
      state.currentRequest.ITEMS.splice(index, 1)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
